module.exports = {
    notAllowed: {
        errorTitle: 'contractsView-depositThirteenMonthsCustomErrorNotAllowedTitle',
        errorBody: 'contractsView-openyoungDataStep2TabForWhom',
        contentBuilder: 'depositThirteenMonthsLeakRetention_customErrorNotAllowed',
        backButtonLabel: 'contractsView-errorBackButtonLabelGlobal',
        backButtonLink: '/myprofile/global'
    }
}